import { Injector, StaticProvider } from '@angular/core';
import { DatasourceServiceDef, IntegrationTabs, provideDatasource } from '@y42/datasource';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { ImpexServiceDef, provideImpex } from '@y42/impex';
import {
  IntegrationAclService,
  IntegrationDataTestService,
  IntegrationGitService,
  IntegrationJobSettingsValidationService,
  IntegrationQuery,
  IntegrationService,
  IntegrationStore,
  IntegrationTableJobQuery,
  IntegrationTableJobService,
  IntegrationTableJobStore,
  IntegrationTableQuery,
  IntegrationTableService,
  IntegrationTableStore,
} from '@y42/integration';
import { JobServiceDef, provideJob } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import { DataTestServiceDef, provideDataTest } from '../data-test/provide-data-test';

const IntegrationJobProviders: () => JobServiceDef = () => {
  return {
    JobService: IntegrationTableJobService,
    JobStore: IntegrationTableJobStore,
    JobQuery: IntegrationTableJobQuery,
    JOB_OVERVIEW_MODELS: (injector: Injector) => injector.get(IntegrationQuery).activeTables$,
    ACTIVE_JOB_OVERVIEW_MODEL: (injector: Injector) => injector.get(IntegrationTableQuery).active$,
  };
};

const IntegrationFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.Integration,
    GIT_FOLDER: Y42GitFolders.Integration,
    FEATURE_ROUTE: Y42Routes.Integration,
    DETAIL_TABS: IntegrationTabs,
    AbstractFeatureService: IntegrationService,
    AbstractFeatureQueryEntity: IntegrationQuery,
    AbstractFeatureEntityStore: IntegrationStore,
    AbstractFeatureGitService: IntegrationGitService,
    AbstractFeatureAclService: IntegrationAclService,
    AbstractFeatureChildQueryEntity: IntegrationTableQuery,
  };
};

const IntegrationDatasourceProviders: () => DatasourceServiceDef = () => {
  return {
    DatasourceService: IntegrationService,
    DatasourceStore: IntegrationStore,
    DatasourceQuery: IntegrationQuery,
    DatasourceTableService: IntegrationTableService,
    DatasourceTableStore: IntegrationTableStore,
    DatasourceTableQuery: IntegrationTableQuery,
    DatasourceTableJobStore: IntegrationTableJobStore,
    DatasourceTableJobQuery: IntegrationTableJobQuery,
    DatasourceGitService: IntegrationGitService,
    DatasourceJobSettingsValidationService: IntegrationJobSettingsValidationService,
  };
};

const IntegrationDataTestProviders: () => DataTestServiceDef = () => ({
  DataTestService: IntegrationDataTestService,
  DataTestParentQuery: IntegrationTableQuery,
});

const IntegrationImpexProviders: () => ImpexServiceDef = () => ({
  ImpexService: IntegrationService,
  ImpexChildService: IntegrationTableService,
  ImpexQuery: IntegrationQuery,
  ImpexChildQuery: IntegrationTableQuery,
});

export function IntegrationProviders(
  options: { feature: boolean; datasource: boolean; job: boolean; dataTest: boolean; impex: boolean } = {
    feature: true,
    datasource: true,
    job: true,
    dataTest: true,
    impex: true,
  },
): StaticProvider[] {
  return [
    options.feature ? provideFeature(IntegrationFeatureProviders()) : [],
    options.datasource ? provideDatasource(IntegrationDatasourceProviders()) : [],
    options.job ? provideJob(IntegrationJobProviders()) : [],
    options.dataTest ? provideDataTest(IntegrationDataTestProviders()) : [],
    options.impex ? provideImpex(IntegrationImpexProviders()) : [],
  ];
}
